import { createFileRoute } from '@tanstack/react-router'
import { ExpenseList, expenseSearchSchema } from '@/features/expense/index.ts'
import { usePersistedListQuery } from '@/hooks/use-persisted-list-query.ts'
import { createListQueryPersistence } from '@/utils/list-query-persistence.ts'

const listQuery = createListQueryPersistence('super-mega:finance:expense-records:list-query', expenseSearchSchema)
export const Route = createFileRoute('/_authenticated/finance/expenses')({
  beforeLoad: listQuery.restore,
  validateSearch: listQuery.validateSearch,
  head: () => ({ meta: [{ title: '支出账单 · Super Mega' }] }),
  component: ExpensesPage
})
function ExpensesPage() {
  const { currentSession } = Route.useRouteContext()
  const { search, navigateSearch } = usePersistedListQuery({
    persistence: listQuery,
    raw: Route.useSearch(),
    accountId: currentSession.id,
    navigate: Route.useNavigate()
  })
  return <ExpenseList session={currentSession} search={search} navigate={navigateSearch} />
}
